import { CustomerInterface } from "../../pages/OrderDetailsPage/OrderDetailsInterface";
import { FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import { dictionary } from "../../utils/dictionary";
import { useAuth } from "../../context/AuthContext";

export const CustomerCard = ({ customer }: { customer: CustomerInterface }) => {
  const { language } = useAuth();
  const fullName = `${customer.name || ""} ${customer.last_name || ""}`.trim();
  const phone = `${customer.prefix_phone || ""} ${customer.phone || ""}`.trim();
  const address = [customer.address, customer.address_detail].filter(Boolean).join(", ");
  const location = [customer.neighborhood, customer.city, customer.department].filter(Boolean).join(" - ");

  const getInitials = () => {
    const nameParts = (fullName || customer.email || "Cliente").split(" ");
    return nameParts
      .map((part) => part.charAt(0))
      .join("")
      .slice(0, 2)
      .toUpperCase();
  };

  const rows = [
    { icon: FiMail, value: customer.email },
    { icon: FiPhone, value: phone },
    { icon: FiMapPin, value: address || location },
  ].filter((row) => row.value);

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold mb-4">{dictionary["customer"][language]}</h2>
      
      <div className="flex min-w-0 items-start gap-3">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-blue-500 text-sm font-semibold text-white">
          {getInitials()}
        </div>
        
        <div className="min-w-0 flex-1">
          <h3 className="break-words font-medium text-gray-900">{fullName || "Cliente Shopify"}</h3>
          <p className="text-sm text-gray-500 mb-2">{dictionary["first-time-customer"][language]}</p>
          
          <div className="space-y-2">
            {rows.map(({ icon: Icon, value }) => (
              <div key={value} className="flex min-w-0 items-start gap-2 text-sm text-gray-600">
                <Icon className="mt-0.5 h-4 w-4 shrink-0 text-gray-400" />
                <span className="min-w-0 break-words">{value}</span>
              </div>
            ))}
            {address && location && (
              <div className="flex min-w-0 items-start gap-2 pl-6 text-sm text-gray-500">
                <span className="min-w-0 break-words">{location}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
